/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import ButtonLink from './buttonLink';

function DoubleMultipleInput(props) {
  const {
    value, onChange, valueKey1, valueKey2, valueKey3, reset, placeholder1, placeholder2, placeholder3, area, required, addAnotherText, type, error, onBlur = () => {}, className, maxLength, items, setItems,
  } = props;
  const [focus, setFocus] = useState(null);

  if (!items && !value) {
    setItems([{
      id: uuidv4(),
      [valueKey1]: '',
      [valueKey2]: '',
    }]);
  }

  if (!items && value) {
    const itemArray = value.map((v) => ({ ...v, id: uuidv4() }));
    setItems(itemArray);
  }

  useEffect(() => {
    if (value) {
      const itemArray = value.map((v) => ({ ...v, id: uuidv4() }));
      setItems(itemArray);
    } else {
      setItems([{
        id: uuidv4(),
        [valueKey1]: '',
        [valueKey2]: '',
      }]);
    }
  }, [reset]);

  const updateOnChange = (newItems) => {
    setItems(newItems);

    // remove ids to return object to orginal state
    const copy = JSON.parse(JSON.stringify(newItems));
    copy.forEach((item) => {
      delete item.id;
    });
    onChange(copy);
  };

  const onChangeItem = ({ id, val, valueKey }) => {
    const item = items.find((i) => i.id === id);
    item[valueKey] = val;

    updateOnChange(items);
  };

  const remove = (id) => {
    const newItems = items.filter((t) => t.id !== id).slice();
    updateOnChange(newItems);
  };

  const addAnother = () => {
    const newItems = items.slice();

    newItems.push({
      id: uuidv4(),
      [valueKey1]: '',
      [valueKey2]: '',
      [valueKey3]: '',
    });
    updateOnChange(newItems);
  };

  return (
    <div className={`${className}`}>
      {items?.map((v, i) => (
        <div key={`item${v.id}`} className="pb-2">
          <div id={`txt${area}${placeholder3}`} className={`relative bg-white block w-full border-0 rounded-md shadow-sm mb-4 ${focus === v.id ? 'ring ring-sentric-dark-gray ring-opacity-50' : ''} ${required ? 'required-star' : ''}`}>
            <input
              className={[
                'border-0 focus:outline-none focus:ring-0 w-full bg-transparent text-md p-2 pl-3 text-sentric-dark-gray pr-24',
                v[valueKey3] ? 'pt-6' : '',
              ].join(' ')}
              id={`item${v.id}`}
              name={`item${v.id}`}
              maxLength={maxLength}
              defaultValue={v[valueKey3]}
              type={type || 'text'}
              onFocus={() => setFocus(v.id)}
              onBlur={() => { setFocus(null); onBlur(); }}
              onChange={(e) => onChangeItem({ id: v.id, val: e.target.value, valueKey: valueKey3 })}
            />
            <label
              className={[
                'absolute pointer-events-none top-0 left-0 flex items-center text-gray-500 p-2 pl-3 pr-3',
                v[valueKey3] ? 'text-xs' : 'text-md',
              ].join(' ')}
              htmlFor={`item${v.id}`}
            >
              {placeholder3}
              {items.length > 1
            && (
            <>
              {' '}
              {i + 1}
            </>
            )}
            </label>
            {items.length > 1 && (
            <button className={`absolute justify-center items-center ${v[valueKey3] ? 'h-14' : 'h-10'} flex right-2 top-0 w-20 text-xs ${focus === v.id ? 'text-sentric-dark-gray' : 'text-sentric-text-gray'}`} type="button" onClick={() => remove(v.id)}>
              <FaMinusCircle className="mr-2" />
              Remove
            </button>
            )}
          </div>
          <div id={`txt${area}${placeholder1}`} className={`relative bg-white block w-full border-0 rounded-md shadow-sm mb-4 ${focus === v.id ? 'ring ring-sentric-dark-gray ring-opacity-50' : ''} ${required ? 'required-star' : ''}`}>
            <input
              className={[
                'border-0 focus:outline-none focus:ring-0 w-full bg-transparent text-md p-2 pl-3 text-sentric-dark-gray pr-24',
                v[valueKey1] ? 'pt-6' : '',
              ].join(' ')}
              id={`item${v.id}`}
              name={`item${v.id}`}
              maxLength={maxLength}
              defaultValue={v[valueKey1]}
              type={type || 'text'}
              onFocus={() => setFocus(v.id)}
              onBlur={() => { setFocus(null); onBlur(); }}
              onChange={(e) => onChangeItem({ id: v.id, val: e.target.value, valueKey: valueKey1 })}
            />
            <label
              className={[
                'absolute pointer-events-none top-0 left-0 flex items-center text-gray-500 p-2 pl-3 pr-3',
                v[valueKey1] ? 'text-xs' : 'text-md',
              ].join(' ')}
              htmlFor={`item${v.id}`}
            >
              {placeholder1}
              {items.length > 1
            && (
            <>
              {' '}
              {i + 1}
            </>
            )}
            </label>
            {items.length > 1 && (
            <button className={`absolute justify-center items-center ${v[valueKey1] ? 'h-14' : 'h-10'} flex right-2 top-0 w-20 text-xs ${focus === v.id ? 'text-sentric-dark-gray' : 'text-sentric-text-gray'}`} type="button" onClick={() => remove(v.id)}>
              <FaMinusCircle className="mr-2" />
              Remove
            </button>
            )}
          </div>
          <div id={`txt${area}${placeholder2}`} className={`relative bg-white block w-full border-0 rounded-md shadow-sm mb-4 ${focus === v.id ? 'ring ring-sentric-dark-gray ring-opacity-50' : ''} ${required ? 'required-star' : ''}`}>

            <input
              className={[
                'border-0 focus:outline-none focus:ring-0 w-full bg-transparent text-md p-2 pl-3 text-sentric-dark-gray pr-24',
                v[valueKey2] ? 'pt-6' : '',
              ].join(' ')}
              id={`item2${v.id}`}
              name={`item2${v.id}`}
              maxLength={maxLength}
              defaultValue={v[valueKey2]}
              type={type || 'text'}
              onFocus={() => setFocus(v.id)}
              onBlur={() => { setFocus(null); onBlur(); }}
              onChange={(e) => onChangeItem({ id: v.id, val: e.target.value, valueKey: valueKey2 })}
            />
            <label
              className={[
                'absolute pointer-events-none top-0 left-0 flex items-center text-gray-500 p-2 pl-3 pr-3',
                v[valueKey2] ? 'text-xs' : 'text-md',
              ].join(' ')}
              htmlFor={`item2${v.id}`}
            >
              {placeholder2}
              {items.length > 1
            && (
            <>
              {' '}
              {i + 1}
            </>
            )}
            </label>

          </div>
        </div>
      ))}
      {!!error
      && <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">{error}</p>}

      <div className="w-full flex items-center justify-end h-4 mt-4 mb-8">
        <ButtonLink id={`btn${area}AddAnother`} className="text-sentric-text-gray flex items-center justify-end" onClick={addAnother}>

          <FaPlusCircle className="mr-2" />
          {' '}
          {addAnotherText}

        </ButtonLink>
      </div>
    </div>

  );
}

export default DoubleMultipleInput;
